export const AUTH_URL = '/api/auth/login';
export const AUTH_TOKEN = 'api/v1/auth/oauth/token';
export const AUTH_ME = 'api/v1/admin/me';
export const USER_LOGOUT = 'api/v1/admin/logout';
export const UPDATE_PASS = 'auth/api/v1/me/info-update'; // auth/api/v1/me/info-update
export const GET_HISTORY = 'api/v1/resto/orders/histories';
export const GET_ORDER_DETAILS = 'api/v1/resto/orders/details/';
export const EXPORT_CSV = 'api/v1/resto/orders/request-csv';
export const CSV_LIST = 'api/v1/resto/orders/csv-list';
export const ACTIVITY_LIST = 'api/v1/admin/logs?';
export const USER_LIST = 'api/v1/admin/users?';
export const ROLE_LIST = 'api/v1/admin/roles?';
export const PERMISSION_LIST = 'api/v1/admin/permissions?';
export const ADMIN_USER = 'api/v1/admin/user/';
export const CREATE_USER = 'api/v1/admin/users/create';
export const ADMIN_ROLE = 'api/v1/admin/role/';
export const ADMIN_PERMISSION = 'api/v1/admin/permission/';
export const CONFIRM_RESTO = 'api/v1/confirm-resto';
export const PROCESSING_TIME = 'api/v1/resto/histories/avg-processing-time';
export const EARNING_HISTORY = 'api/v1/resto/histories/earning';
export const ORDER_RATIO = 'api/v1/resto/histories/order-ratio';
export const RESTO_ORDERS = 'api/v1/resto/orders';
export const ORDER_STATS = 'api/v1/resto/orders/stats';
export const POPULAR_ITEMS = 'api/v1/resto/items/popular';
export const LIFETIME_STATS = 'api/v1/resto/lifetime-stats-with-info';
export const UPDATE_ORDER = 'api/v1/resto/orders/update';
export const REQUEST_SUPPORT = 'api/v1/resto/orders/support-request';
export const ACCEPT_ORDER = 'api/v1/resto/orders/accept-order';
export const CHECK_ACCEPTING_ORDER = 'api/v1/resto/check-accepting-order';
export const RESTO_NOTIFICATIONS = 'api/v1/resto/notifications';
export const RESTO_MENUS = 'api/v1/resto/menu/items';
export const RESTO_MENUS_UPDATE = 'api/v1/resto/menus/update';
export const RESTO_MENU_HOURS_SUGGESTIONS = 'api/v1/resto/menu-hours/suggestions';
export const RESTO_MENU_APPROVALS = 'api/v1/resto/menu/approvals';
export const RESTO_ADDONS = 'api/v1/resto/addons';
export const RESTO_ADDONS_UPDATE = 'api/v1/resto/addons/update';
export const RESTO_CREATE_ITEM = 'api/v1/resto/menu/items';
export const RESTO_UPDATE_ITEM = 'api/v1/resto/menu/items/:itemId';
export const RESTO_GET_ITEM = 'api/v1/resto/menu/items/:itemId';
export const RESTO_DELETE_ITEM = 'api/v1/resto/menu/items/:itemId';
export const RESTO_ITEM_ADDONS = 'api/v1/resto/items/addons';
export const RESTO_CATEGORIES = 'api/v1/resto/menu/categories';
export const RESTO_CATEGORIES_SUGGESTIONS = 'api/v1/resto/menu/categories/suggestions';
export const RESTO_CREATE_CATEGORY = 'api/v1/resto/menu/categories';
export const RESTO_UPDATE_CATEGORY = 'api/v1/resto/menu/categories/:categoryId';
export const RESTO_DELETE_CATEGORY = 'api/v1/resto/menu/categories/:categoryId';
export const ADMIN_RESTAURANT_LIST = 'api/v1/admin/get-restaurants';
export const ADMIN_MANAGE_RESTO = 'api/v1/manage-resto/:id';
export const RESTO_ADMIN_BRANCHES_LIST = 'api/v1/resto-admin/get-restaurants';
export const RESTO_ADMIN_BRANCH_COUNT = 'api/v1/resto-admin/get-total-branches-counts';
export const RESTO_ADMIN_TOTAL_EARNINGS = 'api/v1/resto-admin/get-earning-summery';
export const RESTO_ADMIN_BRANCH_DETAIL = 'api/v1/resto-admin/get-restaurant-info/:id/general-info';
export const RESTO_ADMIN_BRANCH_EARNINGS = 'api/v1/resto-admin/get-restaurant-info/:id/get-earning-summery';
export const RESTO_ADMIN_BRANCH_AVAILABLE_ITEMS = 'api/v1/resto-admin/get-restaurant-info/:id/available-items';
export const RESTO_ADMIN_BRANCH_POPULAR_ITEMS = 'api/v1/resto-admin/get-restaurant-info/:id/popular-items';
export const PING_ORDER_SYNC = 'api/v1/resto/orders/ping-for-sync';
export const NOTIFICATION_ACKNOWLEDGE = 'api/v1/resto/notifications/ack';
export const REFRESH_TOKEN = '/api/v1/auth/oauth/refresh';
export const FCM_SUBSCRIBE = 'api/v1/admin/me/subscribe';

export const SPECIAL_HOLIDAYS_LIST = 'api/v1/resto/holidays';
export const BULK_CREATE_SPECIAL_HOLIDAYS = 'api/v1/resto/holidays/bulk';
export const UPDATE_SPECIAL_HOLIDAYS_BY_ID = 'api/v1/resto/holidays/:id';
export const DELETE_SPECIAL_HOLIDAYS_BY_ID = 'api/v1/resto/holidays/:id';

export const SCHEDULE_LIST_URL = 'api/v1/resto/schedules';
export const UPDATE_SCHEDULES = 'api/v1/resto/schedules';
